import styled from 'styled-components'

import { barnesTheme } from '../../theme/barnesTheme'

export const IntroText = styled.p`
  font-family: ${barnesTheme.fonts.body};
  font-size: 12px;
  font-weight: ${barnesTheme.fontWeights.light};
  color: ${barnesTheme.colors.text};
  line-height: 1.6;
  text-align: justify;
  margin: 0 0 ${barnesTheme.spacing.smallGap} 0;

  @media print {
    font-family: ${barnesTheme.fonts.body} !important;
    font-size: 12px !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    color: ${barnesTheme.colors.text} !important;
    line-height: 1.6 !important;
    text-align: justify !important;
    margin: 0 0 ${barnesTheme.spacing.smallGap} 0 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const PageSubtitle = styled.h3`
  font-family: ${barnesTheme.fonts.heading};
  font-size: 15px;
  font-weight: ${barnesTheme.fontWeights.bold};
  color: ${barnesTheme.colors.accent};
  margin: ${barnesTheme.spacing.smallGap} 0;

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-size: 15px !important;
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    color: ${barnesTheme.colors.accent} !important;
    margin: ${barnesTheme.spacing.smallGap} 0 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const SeparatorLine = styled.div`
  width: 100%;
  height: 1px;
  background: ${barnesTheme.colors.border};
  margin: ${barnesTheme.spacing.contentGap} 0;

  @media print {
    width: 100% !important;
    height: 1px !important;
    background: ${barnesTheme.colors.border} !important;
    margin: ${barnesTheme.spacing.contentGap} 0 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const AdvantagesGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: ${barnesTheme.spacing.contentGap} ${barnesTheme.spacing.sectionGap};
  margin-top: ${barnesTheme.spacing.smallGap};

  @media print {
    display: grid !important;
    grid-template-columns: 1fr 1fr !important;
    gap: ${barnesTheme.spacing.contentGap} ${barnesTheme.spacing.sectionGap} !important;
    margin-top: ${barnesTheme.spacing.smallGap} !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const AdvantageItem = styled.div`
  display: flex;
  align-items: center;
  gap: ${barnesTheme.spacing.smallGap};

  @media print {
    display: flex !important;
    align-items: center !important;
    gap: ${barnesTheme.spacing.smallGap} !important;
  }
`

export const AdvantageIconCircle = styled.div`
  width: 36px;
  height: 36px;
  border: 1px solid ${barnesTheme.colors.border};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;

  svg {
    width: 18px;
    height: 18px;
  }

  @media print {
    width: 36px !important;
    height: 36px !important;
    border: 1px solid ${barnesTheme.colors.border} !important;
    border-radius: 50% !important;
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    flex-shrink: 0 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;

    svg {
      width: 18px !important;
      height: 18px !important;
    }
  }
`

export const BoldText = styled.strong`
  font-weight: ${barnesTheme.fontWeights.bold};
  color: ${barnesTheme.colors.primary};

  @media print {
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    color: ${barnesTheme.colors.primary} !important;
  }
`

export const AdvantageTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  @media print {
    display: flex !important;
    flex-direction: column !important;
  }
`

export const AdvantageTitle = styled.span`
  font-family: ${barnesTheme.fonts.heading};
  font-size: ${barnesTheme.fontSizes.small};
  font-weight: ${barnesTheme.fontWeights.bold};
  color: ${barnesTheme.colors.text};
  letter-spacing: 0.3px;
  white-space: pre-line;

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-size: ${barnesTheme.fontSizes.small} !important;
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    color: ${barnesTheme.colors.text} !important;
    letter-spacing: 0.3px !important;
    white-space: pre-line !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const AdvantageEnglish = styled.span`
  font-family: ${barnesTheme.fonts.body};
  font-size: 10px;
  font-style: italic;
  font-weight: ${barnesTheme.fontWeights.light};
  color: ${barnesTheme.colors.textLight};
  text-transform: uppercase;
  margin-top: 2px;

  @media print {
    font-family: ${barnesTheme.fonts.body} !important;
    font-size: 10px !important;
    font-style: italic !important;
    text-transform: uppercase !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    color: ${barnesTheme.colors.textLight} !important;
    margin-top: 2px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

/* ── Broker Section ──────────────────────────────────────────────── */

export const BrokerSection = styled.div`
  display: flex;
  align-items: flex-start;
  margin-top: 48px;

  @media print {
    display: flex !important;
    align-items: flex-start !important;
    margin-top: 48px !important;
  }
`

export const BrokerLabel = styled.div`
  font-family: ${barnesTheme.fonts.heading};
  font-size: 13px;
  font-weight: ${barnesTheme.fontWeights.bold};
  color: ${barnesTheme.colors.accent};
  flex-shrink: 0;
  padding-top: 24px;

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-size: 13px !important;
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    color: ${barnesTheme.colors.accent} !important;
    padding-top: 24px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const BrokerCard = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-left: auto;
  padding-top: 24px;
  gap: 4px;

  @media print {
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
    margin-left: auto !important;
    padding-top: 24px !important;
    gap: 4px !important;
  }
`

export const BrokerPhoto = styled.img`
  width: 100px;
  height: 100px;
  border-radius: 50%;
  object-fit: cover;

  @media print {
    width: 100px !important;
    height: 100px !important;
    border-radius: 50% !important;
    object-fit: cover !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const BrokerName = styled.span`
  font-family: ${barnesTheme.fonts.heading};
  font-size: 13px;
  font-weight: ${barnesTheme.fontWeights.bold};
  color: ${barnesTheme.colors.primary};
  text-align: center;
  margin-top: 6px;

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-size: 13px !important;
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    color: ${barnesTheme.colors.primary} !important;
    text-align: center !important;
    margin-top: 6px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const BrokerRedLine = styled.div`
  width: 40px;
  height: 2px;
  background: ${barnesTheme.colors.accent};
  margin: 4px 0;

  @media print {
    width: 40px !important;
    height: 2px !important;
    background: ${barnesTheme.colors.accent} !important;
    margin: 4px 0 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const BrokerContact = styled.span`
  font-family: ${barnesTheme.fonts.body};
  font-size: ${barnesTheme.fontSizes.small};
  font-weight: ${barnesTheme.fontWeights.light};
  color: ${barnesTheme.colors.primary};
  text-align: center;

  @media print {
    font-family: ${barnesTheme.fonts.body} !important;
    font-size: ${barnesTheme.fontSizes.small} !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    color: ${barnesTheme.colors.primary} !important;
    text-align: center !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const BrokerOfficeName = styled.span`
  font-family: ${barnesTheme.fonts.heading};
  font-size: ${barnesTheme.fontSizes.body};
  font-weight: ${barnesTheme.fontWeights.bold};
  color: ${barnesTheme.colors.primary};
  text-align: center;
  letter-spacing: 2px;
  margin-top: 6px;

  @media print {
    font-family: ${barnesTheme.fonts.heading} !important;
    font-size: ${barnesTheme.fontSizes.body} !important;
    font-weight: ${barnesTheme.fontWeights.bold} !important;
    color: ${barnesTheme.colors.primary} !important;
    text-align: center !important;
    letter-spacing: 2px !important;
    margin-top: 6px !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`

export const BrokerOfficeAddress = styled.span`
  font-family: ${barnesTheme.fonts.body};
  font-size: 8px;
  font-weight: ${barnesTheme.fontWeights.light};
  color: ${barnesTheme.colors.primary};
  text-align: center;

  @media print {
    font-family: ${barnesTheme.fonts.body} !important;
    font-size: 8px !important;
    font-weight: ${barnesTheme.fontWeights.light} !important;
    color: ${barnesTheme.colors.primary} !important;
    text-align: center !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
`
